var image_upload_default = {
  "container": "yaD0z",
  "disabled": "ZgOis",
  "imageInput": "XEqMr",
  "overlay": "_6sJLD",
  "text": "_2iXmi",
  "shown": "dUJHg",
  "hide": "_6yxtP",
  "spinner": "RT5pP",
  "spin": "BzkEe"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
